var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFacebookFooter = function SvgFacebookFooter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 0c6.627417 0 12 5.372583 12 12 0 5.9136952-4.2777205 10.8282752-9.9076368 11.8182152l-.2172328.0356978v-8.3853913h2.796l.5321739-3.4685217h-3.3281739v-2.25078261c0-.94904348.4648696-1.87408696 1.9554783-1.87408696h1.5130435v-2.95304347c-.8883673-.14376524-1.7860756-.22223625-2.6859131-.23478261-2.7412174 0-4.5328695 1.66121739-4.5328695 4.66904348v2.64365217h-3.04695656v3.4685217h3.04695656v8.3853913l-.21723281-.0356978c-5.62991626-.98994-9.90763679-5.90452-9.90763679-11.8182152 0-6.627417 5.372583-12 12-12z",
    fill: "#fff",
    opacity: 0.3
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookFooter, _extends({
    svgRef: ref
  }, props));
});
export default "https://static.im-cdn.com/mjc/storefront/Cipher/static/media/FacebookFooter.52134c73.svg";
export { ForwardRef as ReactComponent };